import * as configureFeralScan from "./configure.feralscan";
import * as configurePlatypus from "./configure.platypus";
import * as configureCarp from "./configure.carp";
import * as contentFeralScan from "./content.feralscan";
import * as contentPlatypus from "./content.platypus";
import * as contentCarp from "./content.carp";
import * as messages from "./messages";
import { ICustomConfiguration, ICustomContent } from "./ICustomConfiguration";

export const Messages = messages;

export const ActivateAccountTab = "ACTIVATE_ACCOUNT";
export const PasswordChangeTab = "PASSWORD_CHANGE";
export const PasswordResetTab = "PASSWORD_RESET";
export const UserProfileTab = "USER_PROFILE";
export const AdminTab = "ADMIN";
export const SummaryTab = "SUMMARY";
export const MapTab = "MAP";
export const SiteTab = "SITE";
export const SiteDetailTab = "SITE_DETAIL";
export const SiteDetailEventTab = "SITE_DETAIL_EVENT";
export const SiteSelectTab = "SITE_SELECT";
export const SurveyTab = "SURVEY";
export const ContentTab = "CONTENT";
export const WelcomeTab = "WELCOME";
export const CustomComponentTab = "CUSTOM_COMPONENT";

export const AdminAccess = "ADMIN";

/* Product Constants */
export const productPlatypus = "platypus";
export const productFeralscan = "feralscan";
export const productCarp = "carp";

var configurationFile: ICustomConfiguration;
var contentFile: ICustomContent;

switch(process.env.PRODUCT) { 
    case productFeralscan: { 
        configurationFile = configureFeralScan.CustomConfiguration;
        contentFile = contentFeralScan.CustomContent;
        break; 
    } 
    case productPlatypus: { 
        configurationFile = configurePlatypus.CustomConfiguration;
        contentFile = contentPlatypus.CustomContent;
        break; 
    } 
    case productCarp: { 
        configurationFile = configureCarp.CustomConfiguration;
        contentFile = contentCarp.CustomContent;
        break; 
    } 
}

if(configurationFile) {
    configurationFile = {...configurationFile, googleAnalyticsTrackingCode: (window as any).GoogleAnalyticsId };
}

export const content: ICustomContent = contentFile;
export const custom: ICustomConfiguration = configurationFile;
